import { LayerCompact } from "models/Layer";
import { toSnakeCaseKeys } from "utils/helper";

import {
  getAPIService,
  postAPIService,
  deleteAPIService,
  putAPIService,
} from "./BaseServce";
import { Shot, ShotCompact } from "../models/Shot";

export const getShots = async (
  projectId: number,
  page: number,
  searchTerm?: string,
  sortBy?: string,
) => {
  const res = await getAPIService("/shots", {
    project_id: projectId,
    page,
    search_term: searchTerm,
    sort_by: sortBy,
  });
  return res.data;
};

export const createShot = async (
  projectId: number,
  fileName: string,
  footagePath: string,
) => {
  const res = await postAPIService(`/shots`, {
    project_id: projectId,
    file_name: fileName,
    footage_path: footagePath,
  });
  return res.data as ShotCompact;
};

export const getShotDetail = async (shotId: number) => {
  const res = await getAPIService(`/shots/${shotId}`, {});
  return res.data as Shot;
};

export const renameShot = async (id: number, name: string) => {
  const res = await putAPIService(`/shots/${id}`, { name });
  return res.data;
};

export const deleteShot = async (id: number) => {
  const res = await deleteAPIService(`/shots/${id}`);
  return res.data;
};

export const updateUseHq = async (shotId: number) => {
  const res = await postAPIService(`shots/${shotId}/use-hq`, {});
  return res.data;
};

export const runInference = async (id: number, cutouts: number[]) => {
  const res = await postAPIService(`/shots/${id}/run-inference`, { cutouts });
  return res.data;
};

export const retimeInference = async (id: number, retimedLength: number) => {
  const res = await postAPIService(`/shots/${id}/retime-inference`, {
    retimed_length: retimedLength,
  });
  return res.data as LayerCompact;
};

export const canRunInference = async (id: number) => {
  const res = await getAPIService(`/shots/${id}/run-inference`);
  return res.data;
};

export const depthMapInference = async (id: number) => {
  const res = await postAPIService(`/shots/${id}/depthmap-inference`);
  return res.data as LayerCompact;
};

export const smartVectorsInference = async (
  id: number,
  body?: {
    use_roi_flow?: boolean;
    layer_id?: number;
    cutout_id?: number;
    qa_ref_frame?: number;
  },
) => {
  const res = await postAPIService(
    `/shots/${id}/smart-vectors-inference`,
    body,
  );
  return res.data as LayerCompact;
};

export const canRunTrackingInference = async (id: number) => {
  const res = await getAPIService(`/shots/${id}/tracking-inference`);
  return res.data;
};

export const runTrackingInference = async (shotId: number, cameraDetails) => {
  const res = await postAPIService(`/shots/${shotId}/tracking-inference`, {
    camera_details: toSnakeCaseKeys(cameraDetails),
  });
  return res.data;
};

export const runAutopilotInference = async (shotId: number) => {
  const res = await postAPIService(`/shots/${shotId}/autopilot-inference`, {});
  return res.data;
};
